import { useState } from "react";

import { Camera, CameraResultType, CameraSource } from "@capacitor/camera";

export interface UserPhoto {
  filepath: string;
  webviewPath?: string;
}

export function usePhotoGallery() {
  const [photos, setPhotos] = useState<UserPhoto[]>([]);

  const takePhoto = async () => {
    const photo = await Camera.getPhoto({
      resultType: CameraResultType.Uri,
      source: CameraSource.Camera,
      quality: 100,
    });

    const fileName = new Date().getTime() + ".jpeg";
    const newPhotos = [
      {
        filepath: fileName,
        webviewPath: photo.webPath,
      },
      ...photos,
    ];
    setPhotos(newPhotos);

    return { webPath: photo.webPath, fileName: fileName };
  };

  const clearPhoto = async () => {
    setPhotos([]);
  };

  return {
    photos,
    takePhoto,
    clearPhoto,
  };
}
